import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "using-with-react"
    }}>{`Using with React`}</h1>
    <p>{`React has a history with Web Components, and this history can often lead to confusing issues. React is not technically incorrect in each of these cases, but it can feel surprising as a developer, and the correct use can often feel non-idiomatic.`}</p>
    <h2 {...{
      "id": "no-self-closing-tags"
    }}>{`No self-closing tags`}</h2>
    <p>{`Web Components do not support tags that are self-closing. As such, you must always have the full ending tag.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-icon></sp-icon>
`}</code></pre>
    <h2 {...{
      "id": "use-class-instead-of-classname"
    }}>{`Use `}<inlineCode parentName="h2">{`class`}</inlineCode>{` instead of `}<inlineCode parentName="h2">{`className`}</inlineCode></h2>
    <p>{`Web Components in React use `}<inlineCode parentName="p">{`class`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`className`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "boolean-attributes"
    }}>{`Boolean attributes`}</h2>
    <p>{`When using React with a standard checkbox, you could write something like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<input type="checkbox" checked={checked} />
`}</code></pre>
    <p>{`This will not work when using `}<inlineCode parentName="p">{`sp-checkbox`}</inlineCode>{`, for example, because `}<inlineCode parentName="p">{`checked`}</inlineCode>{` is not treated as a boolean attribute. Instead, React falls back to the web standard for attributes: any value (even a string-coerced "false") is treated as `}<inlineCode parentName="p">{`true`}</inlineCode>{`. Instead, the web expects `}<inlineCode parentName="p">{`checked`}</inlineCode>{` to not be present `}<em parentName="p">{`at all`}</em>{` if the checkbox should be unchecked.`}</p>
    <p>{`In React, this means you need to write the following code so that React knows `}<em parentName="p">{`not`}</em>{` to emit the attribute:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<sp-checkbox checked={checked ? true : undefined}></sp-checkbox>
`}</code></pre>
    <h2 {...{
      "id": "event-handling"
    }}>{`Event Handling`}</h2>
    <p>{`React does not attach event listeners to elements that are Web Components. This is again, technically correct, as React can't know that a particular attribute is an event handler, but it does lead to surprising results that feel broken as event handlers aren't called correctly.`}</p>
    <p>{`The simplest fix is to add a `}<inlineCode parentName="p">{`ref`}</inlineCode>{` to the component and attach event listeners. This results in a lot of unnecessary code, and so we built a `}<a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples/blob/main/ui-react-starter/src/components/WC.jsx"
      }}>{`simple wrapper comonent (WC)`}</a>{` that takes care of the hard work for us. You'll see examples of this in our `}<a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples/blob/main/ui-react-starter/src/components/ColorPicker.jsx#L40"
      }}>{`plugin samples`}</a>{` where we wrap Spectrum UXP components with this component.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      